export enum PriceItemDataHooks {
  Item = 'price-item',
  Label = 'price-item-label',
  Price = 'price-item-description',
}
